import React, { useEffect, useState } from "react";
import { Layers, Plus } from "lucide-react";
import { loadProducts, loadStacks } from "./ResearchStacks";

// "Add MOTS-c to complete the Metabolic Stack and save 5%" — shown when exactly one item is missing.
export default function CartStackHint({ items, addItem, wholesale }) {
  const [cfg, setCfg] = useState({ stacks: [], max_line_qty: 5 });
  const [all, setAll] = useState([]);
  useEffect(() => { loadStacks().then(setCfg); loadProducts().then(setAll); }, []);
  if (wholesale || !items.length) return null;

  const inCart = new Set(items.filter((i) => i.quantity >= 1 && i.quantity <= cfg.max_line_qty).map((i) => i.slug));
  const anyInCart = new Set(items.map((i) => i.slug));
  const bySlug = Object.fromEntries(all.map((p) => [p.slug, p]));
  const hints = cfg.stacks
    .map((s) => ({ s, missing: s.slugs.filter((x) => !inCart.has(x)) }))
    .filter(({ s, missing }) => Number(s.percent_off) > 0 && missing.length === 1 && !anyInCart.has(missing[0]) && bySlug[missing[0]]?.variants?.length)
    .map(({ s, missing }) => ({ stack: s, product: bySlug[missing[0]] }));
  if (!hints.length) return null;

  return (
    <div data-testid="cart-stack-hints" className="space-y-2">
      {hints.map(({ stack, product }) => (
        <div key={stack.name} data-testid={`cart-stack-hint-${product.slug}`} className="flex items-center gap-3 p-3 border border-[#00C3FF]/40 bg-[#00C3FF]/5">
          <Layers size={14} className="text-[#00C3FF] shrink-0" />
          <div className="flex-1 text-xs text-[#8A94A6] leading-relaxed">
            Add <span className="text-white">{product.name}</span> to complete the <span className="text-white">{stack.name}</span> and save <span className="text-[#00C3FF]">{stack.percent_off}%</span>
          </div>
          <button
            data-testid={`cart-stack-hint-add-${product.slug}`}
            onClick={() => addItem(product, product.variants[0], 1)}
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-[#00C3FF] text-[#05050A] font-mono-tech text-[10px] uppercase tracking-[0.15em] hover:bg-white transition-colors shrink-0"
          >
            <Plus size={12} /> ${Number(product.variants[0].price).toFixed(2)}
          </button>
        </div>
      ))}
    </div>
  );
}
